<template>
    <div>
        <form-row title="When is it Non-Refundable?">
            <div class="flex flex-col sm:flex-row sm:items-end">
                <div class="-mt-4">
                    <input-date
                        label="Date"
                        name="earnest_money_non_refundable_date"
                        v-model="earnest_money_non_refundable_date"
                        :read_only="read_only"
                        @entered="dateEntered"
                    />
                </div>

                <div class="mt-4 sm:mt-0 flex items-center">
                    <span class="flex-none text-sm text-gray-warm-800 sm:pl-6 pr-6">
                        {{ $t('- OR -') }}
                    </span>

                    <div class="flex-none w-16 sm:w-1/5">
                        <input-text
                            name="earnest_money_non_refundable_period"
                            v-model="earnest_money_non_refundable_period"
                            placeholder="Days"
                            :read_only="read_only"
                            @input="periodEntered"
                        />
                    </div>

                    <span class="text-sm text-gray-warm-800 leading-snug pl-4">
                        {{ $t('days after Feasibility / Due Diligence') }}
                    </span>
                </div>
            </div>
        </form-row>
    </div>
</template>

<script>
import DateFunctions from '../../../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        commercial: {},
        read_only: { default: false },
    },

    data() {
        return {
            earnest_money_non_refundable_period: this.commercial.earnest_money_non_refundable_period,
            earnest_money_non_refundable_date: this.commercial.earnest_money_non_refundable_date,
        }
    },

    computed: {
        earnest_money_non_refundable_date_from_period() {
            if (! store.state.feasibility_date) {
                return;
            }

            if (this.isValidDate(store.state.feasibility_date) && this.earnest_money_non_refundable_period) {
                return dayjs(store.state.feasibility_date.slice(0, 10))
                    .add({ day: this.earnest_money_non_refundable_period })
                    .format('YYYY-MM-DD');
            }
        },
    },

    methods: {
        dateEntered() {
            this.earnest_money_non_refundable_period = null;
        },
        periodEntered(value) {
            if (! value || ! store.state.feasibility_date) {
                this.earnest_money_non_refundable_date = null;
            }
        },
    },

    watch: {
        earnest_money_non_refundable_date_from_period(val) {
            if (val) {
                this.earnest_money_non_refundable_date = val;
            }
        },
        earnest_money_non_refundable_date(val) {
            this.$emit('updated', val);
        },
    },
}
</script>
